/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PtOtFunctionScoreRange } from './PtOtFunctionScoreRange';
import {
    PtOtFunctionScoreRangeFromJSON,
    PtOtFunctionScoreRangeFromJSONTyped,
    PtOtFunctionScoreRangeToJSON,
    PtOtFunctionScoreRangeToJSONTyped,
} from './PtOtFunctionScoreRange';
import type { PtOtCaseMixGroup } from './PtOtCaseMixGroup';
import {
    PtOtCaseMixGroupFromJSON,
    PtOtCaseMixGroupFromJSONTyped,
    PtOtCaseMixGroupToJSON,
    PtOtCaseMixGroupToJSONTyped,
} from './PtOtCaseMixGroup';

/**
 * 
 * @export
 * @interface PtOtCaseMixGroupScoreRange
 */
export interface PtOtCaseMixGroupScoreRange {
    /**
     * 
     */
    function_score_range: PtOtFunctionScoreRange;
    /**
     * 
     */
    case_mix_group: PtOtCaseMixGroup;
}



/**
 * Check if a given object implements the PtOtCaseMixGroupScoreRange interface.
 */
export function instanceOfPtOtCaseMixGroupScoreRange(value: object): value is PtOtCaseMixGroupScoreRange {
    if (!('function_score_range' in value) || value['function_score_range'] === undefined) return false;
    if (!('case_mix_group' in value) || value['case_mix_group'] === undefined) return false;
    return true;
}

export function PtOtCaseMixGroupScoreRangeFromJSON(json: any): PtOtCaseMixGroupScoreRange {
    return PtOtCaseMixGroupScoreRangeFromJSONTyped(json, false);
}

export function PtOtCaseMixGroupScoreRangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PtOtCaseMixGroupScoreRange {
    if (json == null) {
        return json;
    }
    return {
        
        'function_score_range': PtOtFunctionScoreRangeFromJSON(json['function_score_range']),
        'case_mix_group': PtOtCaseMixGroupFromJSON(json['case_mix_group']),
    };
}

export function PtOtCaseMixGroupScoreRangeToJSON(json: any): PtOtCaseMixGroupScoreRange {
    return PtOtCaseMixGroupScoreRangeToJSONTyped(json, false);
}

export function PtOtCaseMixGroupScoreRangeToJSONTyped(value?: PtOtCaseMixGroupScoreRange | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'function_score_range': PtOtFunctionScoreRangeToJSON(value['function_score_range']),
        'case_mix_group': PtOtCaseMixGroupToJSON(value['case_mix_group']),
    };
}

